import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import CenterList from './CenterList';
import CenterDetail from './CenterDetail';

@inject(({ commonStore, centerInfoStore }) => ({
  commonStore: commonStore,
  sessionLoginInfo: commonStore.sessionLoginInfo,
  setCommonStoreInfo: centerInfoStore.setCommonStoreInfo,
  
  onClear: centerInfoStore.onClear,
  viewMode: centerInfoStore.viewMode,
  onViewMode: centerInfoStore.onViewMode,
  disCenterList: centerInfoStore.disCenterList,
}))
@observer
class CenterContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disCenterList(1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/centerManage');
      } else {
        this.props.history.push('/centerManage/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { sessionLoginInfo } = this.props;
    return (
      this.props.viewMode === 'list'
      ? <CenterList
          sessionLoginInfo={sessionLoginInfo}
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
          cGbn={(sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) 
            ? sessionLoginInfo.cGbn : "" }          
        /> 
      : <CenterDetail />
    );
  }

}

export default withRouter(CenterContainer);
